import { API_ENDPOINTS } from "config/apiConfig";
import { baseApi } from "./baseApi";

export type RankingRole = "seller" | "buyer";
export type RankingSortOrder = "desc" | "asc";

export interface RankingItem {
  rank: number;
  company_id: string;
  company_code: string | null;
  company_name: string | null;
  company_logo_url: string | null;
  role: RankingRole;
  level: number;
  total_xp: number;
  category_id: number | null;
  total_volume_kg: number;
}

export interface UnrankedRankingItem {
  rank: null;
  company_id: string;
  company_code: string | null;
  company_name: string | null;
  company_logo_url?: string | null;
  role: RankingRole;
}

export interface RankingMyRank {
  ranked: boolean;
  label: string | null;
  item: RankingItem | UnrankedRankingItem;
}

export interface RankingPage {
  items: RankingItem[];
  meta: {
    total_pages: number;
    current_page: number;
  };
  my_rank: RankingMyRank | null;
}

export interface GlobalCounterData {
  total_circulation_kg: number;
  products_on_sale: number;
  deals_today: number;
  participating_companies: number;
  completed_deals: number;
  calculated_at: string;
}

interface ApiResponse<T> {
  data: T;
  success: boolean;
  message: string;
}

interface MaterialRankingParams {
  role: RankingRole;
  category_id?: number;
  page: number;
  limit: number;
  sort_order?: RankingSortOrder;
}

export const rankingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getMaterialRanking: builder.query<
      ApiResponse<RankingPage>,
      MaterialRankingParams
    >({
      query: (params) => ({
        url: API_ENDPOINTS.RANKING_MATERIALS,
        params,
      }),
      providesTags: ["Ranking"],
    }),
    getGlobalCounter: builder.query<ApiResponse<GlobalCounterData>, void>({
      query: () => ({
        url: API_ENDPOINTS.GLOBAL_COUNTER,
      }),
      providesTags: ["Ranking"],
    }),
  }),
});

export const { useGetMaterialRankingQuery, useGetGlobalCounterQuery } =
  rankingApi;
